var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v(" "+_vm._s(_vm.$t("ResultsIndicatorShowing"))+" "),_c('strong',[_vm._v(_vm._s(_vm.first)+" - "+_vm._s(_vm.last))]),_vm._v(" "+_vm._s(_vm.$t("ResultsIndicatorOf"))+" "),_c('strong',[_vm._v(_vm._s(_vm.total))]),_vm._v(" "+_vm._s(_vm.$t("ResultsIndicatorFor"))+" "),_c('strong',[_vm._v(_vm._s(_vm.term))])])
}
var staticRenderFns = []

export { render, staticRenderFns }